import { debugLog } from "../debugLog";

async function isReallyOnline(timeoutMs = 2000) {
  const controller = new AbortController();
  const t = setTimeout(() => controller.abort('timeout'), timeoutMs);

  try {
    const res = await fetch('/_network-check?t=' + Date.now(), {
      cache: 'no-store',
      credentials: 'omit',
      signal: controller.signal,
    });

    return res.ok;
  } catch (_) {
    return false;
  } finally {
    clearTimeout(t);
  }
}

// pgw 17-may-2026 - shared implementation for Settings "Refresh app"
// and the remote app-version update dialog. Keep this logic equivalent to the
// original Settings refreshApp handler: warn if offline, clear Cache API entries,
// unregister service workers, then reload the page.
export async function refreshChoirPlayerApp({ source = "unknown", confirmIfOffline = true } = {}) {
  debugLog("[refreshApp] start", source);

  if (confirmIfOffline) {
    const ok = await isReallyOnline(2500);

    if (ok) {
      debugLog('user is online');
    } else {
      debugLog('user is offline !!');

      const res = window.confirm(
        "You are offline.\nDoing this will cause the app to stop working !\n Are you sure you want to continue ?\n(OK to continue; Cancel to do nothing) ?"
      );

      debugLog('res = ', res);

      if (res) {
        debugLog("You pressed OK!");
      } else {
        debugLog("You pressed Cancel - returning...");
        return false;
      }
    }
  }

  const doRefresh = true;

  // (D) CACHE API
  if (doRefresh) {
    debugLog("[clear] D: deleting Cache API entries");

    try {
      if (typeof caches !== "undefined" && caches && typeof caches.keys === "function") {
        const cacheNames = await caches.keys();

        if (cacheNames && cacheNames.length > 0) {
          for (let k = 0; k < cacheNames.length; k++) {
            const name = cacheNames[k];
            debugLog("[clear] D: delete cache:", name);

            try {
              await caches.delete(name);
            } catch (eDdel) {
              debugLog("[clear] D: caches.delete error for", name, "=", eDdel);
            }
          }
        } else {
          debugLog("[clear] D: no caches to delete");
        }
      } else {
        debugLog("[clear] D: Cache API not available → skip");
      }
    } catch (eD) {
      debugLog("[clear] D: Cache API error =", eD);
    }
  } else {
    debugLog("[clear] D: clearCaches = false → skip");
  }

  // (E) SERVICE WORKERS
  if (doRefresh) {
    debugLog("[clear] E: unregistering all Service Workers");

    try {
      if (typeof navigator !== "undefined" && navigator && navigator.serviceWorker && typeof navigator.serviceWorker.getRegistrations === "function") {
        const registrations = await navigator.serviceWorker.getRegistrations();

        if (registrations && registrations.length > 0) {
          for (let r = 0; r < registrations.length; r++) {
            const reg = registrations[r];

            try {
              const ok = await reg.unregister();
              debugLog("[clear] E: unregister", ok ? "OK" : "failed", "scope:", reg && reg.scope);
            } catch (eEun) {
              debugLog("[clear] E: unregister error =", eEun);
            }
          }
        } else {
          debugLog("[clear] E: no registrations found");
        }
      } else {
        debugLog("[clear] E: serviceWorker API not available → skip");
      }
    } catch (eE) {
      debugLog("[clear] E: SW error =", eE);
    }
  } else {
    debugLog("[clear] E: unregisterSW = false → skip");
  }

  if (doRefresh) {
    debugLog("[reload] softReload = true → window.location.reload()");

    try {
      window.location.reload();
    } catch (eR2) {
      debugLog("[reload] softReload error =", eR2);
    }
  } else {
    debugLog("[reload] softReload = false → skip");
  }

  return true;
}
